module.exports = __webpack_public_path__ + "static/media/headshot.de2ce48f.png";